import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography } from '@material-ui/core';
import { ImageSection } from 'app/components/ImageSection';
import { DownloadChecklist } from 'app/components/DownloadChecklist';
import { RootState } from 'app/store/types';
import { routes } from 'app/routes/route-list';
import { GoToClosingCostButton } from 'app/components/ClosingCost/GoToClosingCostButton';
import { getFormType } from '../routes/helpers';
import { DocumentUploadButton } from 'app/components/DocumentUploadButton';
import { GoToInsuranceQuoteButton } from 'app/components/InsuranceQuote/GoToInsuranceQuoteButton';
import { getLinksByForm } from '../reducers/app-config';
import { OpenInNew } from '@material-ui/icons';

type MappedProps = ReturnType<typeof mapStateToProps>;

const ConfirmationComponent = (props: MappedProps) => {
  const { confirmationImage, isCommercialApp, isPurchaseOrRefiApp, links } = props;
  const { t } = useTranslation();
  const isDisplayChecklist = !isCommercialApp;

  return (
    <Grid container={false}>
      <Grid item classes={{ item: 'noStepper' }}>
        <ImageSection image={confirmationImage}>
          <Typography variant='h6' classes={{ h6: 'titleMargin section' }}>
            {t('confirmation.title', { defaultValue: 'Thank you!' })}
          </Typography>
          <Typography variant='body2' paragraph={true}>
            {t('confirmation.paragraph1', {
              defaultValue:
                'A mortgage loan officer will contact you to discuss your options and next steps.',
            })}
          </Typography>
          { isDisplayChecklist && <DownloadChecklist /> }
          <Grid container justifyContent='center'>
            <Grid item xs={12}>
              <DocumentUploadButton />
            </Grid>
          </Grid>
          <GoToClosingCostButton/>
          { isPurchaseOrRefiApp && <GoToInsuranceQuoteButton /> }
          <Grid container justifyContent='center'>
            <Grid item xs={12}>
              {
                links.map(({ title, url }, index) => {
                  return <Grid key={index} item xs={12}>
                    <Button
                      classes = { { root: 'longButton' } }
                      color   = 'primary'
                      variant = 'contained'
                      rel     = 'noopener'
                      target  = '_blank'
                      href    = { url }
                      endIcon = {<OpenInNew />}
                    >
                      { title }
                    </Button>
                  </Grid>;
                })
              }
            </Grid>
          </Grid>
        </ImageSection>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: RootState, ownProps: any) => ({
  confirmationImage : state.config.confirmationImage,
  formName : getFormType(state.router.location.pathname),
  isPurchaseOrRefiApp:
    state.router.location.pathname === routes.applicationPurchase ||
    state.router.location.pathname === routes.applicationRefinance ||
    state.router.location.pathname === routes.purchaseTurbo,
  isCommercialApp   :
    state.router.location.pathname === routes.commercialPurchase ||
    state.router.location.pathname === routes.commercialRefinance,
  ...ownProps,
  links : getLinksByForm(state),
});

export const Confirmation = connect(mapStateToProps)(ConfirmationComponent);
